import { Injectable } from '@angular/core';
import { Http , Response} from '@angular/http';
import { FlashMessagesService } from 'angular2-flash-messages';
import { Utils } from '../shared/utils';

import { Router } from '@angular/router';

import 'rxjs/add/operator/toPromise';

import { Participante } from './participante';
import { Upload } from '../uploads/upload';
@Injectable()
export class ParticipanteService {

  private participanteUrl = '/participantes';
  private participanteIndUrl = '/envio';

  constructor(
    private http: Http,
    private _flashMessagesService: FlashMessagesService,
    private router: Router,
    private utils: Utils) {
  }

  pegarTodosParticipantes(params?: any): Promise<Participante[]> {

    return this.http.get(this.participanteUrl, {search: this.utils.buildParams(params)})
                .toPromise()
                .then(response => response.json().dados as Participante[])
                .catch((error) => this.handleError(error));
  }

  getParticipante(id: number): Promise<Participante>{
    let url: string  = this.participanteUrl + '/' + id;
    return this.http.get(url)
               .toPromise()
               .then(response => response.json().dados as Participante)
               .catch((error) => this.handleError(error));
  }

  deleteParticipante(participante: number, upload: number): Promise<Response>{
    let url: string = this.participanteUrl + '/' + participante + '/' + upload;
    return this.http
               .delete(url)
               .toPromise()
               .then(response => this.handleSuccess(response.json()))
               .catch((error) => this.handleError(error));
  }

  saveParticipante(participante: Participante, upload: Upload): Promise<Response>{
    let url: string = this.participanteUrl

    if(participante.id){
     url =  url + '/' + participante.id;
   } else {
     url = url + '/novo/' + upload.id
   }

    return this.http
               .post(url, this.utils.buildFormData(participante))
               .toPromise()
               .then(response => this.handleSuccess(response.json()))
               .catch((error) => this.handleError(error));
  }

  saveUpdateListaParticipante(participante: Participante, upload: Upload): Promise<Response>{
    let url: string = this.participanteUrl

    if(participante.id){
     url =  url + '/update_lista_participante/' + participante.id;
   } else {
     url = url + '/novo/' + upload.id
   }

    return this.http
               .post(url, this.utils.buildFormData(participante))
               .toPromise()
               .then(response => this.handleSuccess(response.json()))
               .catch((error) => this.handleError(error));
  }

  atualizarParticipante(participante: Participante): Promise<Response>{
    let url: string = this.participanteUrl+ '/' + participante.id;

    return this.http
               .post(url, this.utils.buildFormData(participante))
               .toPromise()
               .then(response => this.handleSuccess(response.json()))
               .catch((error) => this.handleError(error));
  }

  agendar(participanteId: number, uploadId: number): Promise<Response>{
    let url: string = this.participanteIndUrl + '/agendar/' + uploadId + '/' + participanteId ;
    return this.http
                .get(url)
                .toPromise()
                .then(response =>this.handleSuccess(response.json()))
                .catch((error) => this.handleError(error));
  }

  meusCertificados(params?: any): Promise<any[]>{
    let url: string = this.participanteUrl + '/meusCertificados';
    return this.http
                .get(url, {search: this.utils.buildParams(params)}  as any)
                .toPromise()
                .then(response => response.json().dados as any[])
                .catch((error) => this.handleError(error));
  }

  getTodosCertificadosPorCPF(params?: any): Promise<any[]>{
    let url: string = this.participanteUrl + '/certificadosPorCPF';
    return this.http
                .get(url, {search: this.utils.buildParams(params)})
                .toPromise()
                .then(response => response.json().dados as any[])
                .catch((error) => this.handleError(error));
  }

  transferirCertificados(dados: {
    participante_origem_id: number,
    participante_destino_id: number,
    upload_participantes_ids?: number[],
    transferir_todos?: boolean,
    manter_identificador?: boolean,
    observacao?: string
  }): Promise<any> {
    let url: string = this.participanteUrl + '/transferir-certificados';
    
    return this.http
      .post(url, this.utils.buildFormData(dados))
      .toPromise()
      .then(response => this.handleSuccess(response.json()))
      .catch((error) => this.handleError(error));
  }

  private handleSuccess(resp: any): Promise<any> {
    this.utils.flashMessage(resp.msg, 'success');
    //this._flashMessagesService.show(resp.msg, { cssClass: 'card alert-success', timeout: 5000 });
    return resp;
  }

  private handleError(error: any): Promise<any> {
     switch (error.status) {
      case 500:
        this.utils.flashMessage('Ocorreu error no servidor, entre em contato com o administrador.', 'danger');
        //this._flashMessagesService.show("Ocorreu error no servidor, entre em contato com o administrador.", { cssClass: 'card alert-danger', timeout: 5000 });
        break;
      case 403:
        this.utils.flashMessage(error.json().msg, 'warning');
        //this._flashMessagesService.show(error.json().msg, { cssClass: 'card alert-warning', timeout: 5000 });
        break;
      default:
      this.utils.flashMessage("Ocorreu um error, tente novamente mais tarde.", 'danger');
        //this._flashMessagesService.show("Ocorreu um error, tente novamente mais tarde.", { cssClass: 'card alert-danger', timeout: 5000 });
    }
    return Promise.reject(error.message || error);
  }

}



// WEBPACK FOOTER //
// ./src/app/participantes/participante.service.ts